/**
 * Created by Thomas Mark
 * Date: 2021-04-01
 * 
 * In dieser Komponente wird das PNG-Preview-Image eines PDF-Dokuemntes angezeigt.
 * Klickt der Benutzer auf das PNG-Preview-Image, dann wird der PdfController gestartet,
 * um das eigentliche PDF-Dokument anzuzeigen.
 * 
 * Falls dieser Komponente ein Node mit 'name' = '_NEW' übergeben wurde, dann wird anstelle
 * des PNG-Preview-Images ein UploadArea angezeigt. Hier hat der Benutzer dann die Möglichkeit 
 * per Drag & Drop oder Dateiauswahl-Dialog ein neues PDF-Dokument hochzuladen.  
 * 
 * Aktionen:
 * - Bei Klick auf das PDF-Image wird das PDF-Dokument mittels PdfController.js angezeigt.
 * - Bei Klick auf Mülleimer-Symbol wird das PDF-Dokument gelöscht
 * - Bei Drag & Drop oder Klick wird ein PDF-Dokument hochgeladen 
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import UploadArea from "./UploadArea";
import { FabIconDelete } from "./Icons";
import { MdOutlineFileDownload } from 'react-icons/md';

import * as portfolioActions from '../../store/actions/portfolioActions';
import * as fileActions from "../../store/actions/fileActions";
import * as appActions from "../../store/actions/appActions";
import * as utils from "../../basics/utils";
import * as cordova from "../../basics/cordova";
import { ImageLoader } from "./ImageLoader";

class PDFFrame extends React.Component {
    constructor(props) {
        super(props)

        this.debug = false
    }


    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, orientation, path, appModus, currentContainer } = this.props.app
        const { currentPortfolio } = this.props.portfolio;

        let height = (orientation === 'landscape') ? inputHeight * .43 : inputHeight * .28;
        if (this.props.type === 'portfolio') {
            height = (orientation === 'landscape') ? inputHeight * .43 : inputHeight * .21;
        }

        if (this.props.listView) height *= .55;

        const width = height / Math.sqrt(2);

        const d = this.props.node

        this.clicked = false;

        // ==========================================================================
        // 
        // CALLBACK SECTION
        // 
        // ==========================================================================
        const onClick = (viewOnly) => {

            let fileName = d.name;
            let filePath = d.path;
            if (this.props.listView) {
                const pdf = utils.getListViewPDF(d);
                fileName = pdf.name;
                filePath = pdf.path;
            }

            let sID = `${currentContainer}_${utils.cyrb53(filePath)}_${fileName}`;

            if (appModus === 'Admin') {
                sID = `${filePath.replaceAll('/', ':')}/${fileName}`;
            }

            cordova.viewPDF(sID, viewOnly);
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================
        const renderItemNew = () => {

            const style = {
                height: (height) + 'px',
                minHeight: (height) + 'px',
                width: (width) + 'px'
            }

            return (
                <div className="flex border-gray-600" style={style}>
                    <UploadArea uploadArea='pdf' uploadType={this.props.type} uploadPath={path} uploadPost='' />
                </div>
            )
        }

        const renderDownloadButton = () => {
            if (window['cordova']) return null;

            const className = "absolute bottom-2 right-2 w-8 h-8 flex items-center justify-center rounded-full px-2 text-white bg-gray-400";

            return (
                <div className={className} onClick={() => onClick(false)}>
                    <MdOutlineFileDownload />
                </div>
            )
        }

        const renderItem = () => {


            const onDelete = () => {

                const onDeleteSuccess = (data) => {
                    this.props.scanPortfolio(currentPortfolio.name);
                }

                const onDeleteError = (error) => {
                    console.log('onDelete() error:', error);
                }

                // Datei über REST-API löschen
                this.props.deleteFile(this.props.type, path, d.name, onDeleteSuccess, onDeleteError);
            }

            // ==========================================================================
            // SUB RENDER
            // ==========================================================================

            const stylePDFFrame = {
                borderWidth: '0px',
                borderColor: 'gray',
                boxShadow: '3px 3px 3px lightgray'
            }

            let style = {};
            if (appModus === 'Admin') {
                const url = utils.getURL(this.props.type, path, d.name.replace('.pdf', '.png'));

                if (url) {
                    style = { ...utils.getStyleBackgroundURL(url), ...stylePDFFrame };
                }

                return (
                    <div className="relative flex w-full h-full" style={style} >
                        <Button className="flex w-full" onClick={() => onClick(true)}></Button>
                        {appModus === 'Admin' && FabIconDelete("PDF-Dokument entfernen", onDelete)}
                    </div>
                )

            } else {
                if (!this.props.node) return null;

                let filePath = this.props.node.path;
                let fileName = this.props.node.name;

                if (this.props.listView) {
                    const pdf = utils.getListViewPDF(d);
                    filePath = pdf.path;
                    fileName = pdf.name;
                }

                if (fileName === '') return null;

                return (
                    <div className="relative flex w-full h-full" style={stylePDFFrame} onClick={() => onClick(true)}>
                        <ImageLoader path={filePath} name={fileName} height={'100%'} cover={'cover'} />
                        {renderDownloadButton()}
                    </div>
                )
            }
        }


        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            backgroundColor: 'transparent',
            height: (height) + 'px',
            minHeight: (height) + 'px',
            width: (width) + 'px',
            minWidth: (width) + 'px',
        }

        return (
            <div className={"relative flex items-center justify-center"} style={style} >
                {d.name === '_NEW' ? renderItemNew() : renderItem()}

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PDFFrame)
